var map = {
	"./1.jpeg": "0201",
	"./2.jpeg": "f966",
	"./3.jpeg": "c709",
	"./4.jpeg": "3565",
	"./5.jpeg": "16ef",
	"./6.jpeg": "ec88",
	"./7.jpeg": "f5bf",
	"./8.png": "ae14",
	"./9.jpeg": "362c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a531";